import React from 'react';
const font = 'Poppins, system-ui, sans-serif';
function Dot({
  x,
  y,
  fill,
  label,
  dark = false
}: {
  x: number;
  y: number;
  fill: string;
  label: string;
  dark?: boolean;
}) {
  return <g data-id="element-88" data-mp="3rhrnkzsoireg">
      <circle cx={x} cy={y} r="13" fill={fill} stroke="#FFFFFF" strokeWidth="2.5" data-id="element-89" data-mp="3rhhw17rzkc6n" />
      <text x={x} y={y + 4.5} textAnchor="middle" fontSize="12" fontWeight="800" fill={dark ? '#10233A' : '#FFFFFF'} fontFamily={font} data-id="element-90" data-mp="3miy8x41noucp">
        {label}
      </text>
    </g>;
}

/** Top-down badminton court, drawn in the pack's diagram language. */
export function CourtDiagram({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 300 480" role="img" aria-label="Top-down court diagram with coach, feeder and players" className={`h-auto w-full ${className}`} data-id="element-91" data-mp="38k6wrn6ctir7">
      <defs data-id="element-92" data-mp="33mf7z210acr8">
        <marker id="arrow" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="7" markerHeight="7" orient="auto-start-reverse" data-id="element-93" data-mp="16risdahz4p9u">
          <path d="M0 0 L10 5 L0 10 z" fill="#10233A" data-id="element-94" data-mp="11tr18ip5l76p" />
        </marker>
      </defs>
      <rect x="50" y="20" width="200" height="440" rx="4" fill="#E4EFFC" data-id="element-95" data-mp="1yzy1272x6826" />
      <g stroke="#1C6DD0" strokeWidth="2" fill="none" data-id="element-96" data-mp="23zj0eim04iff">
        <rect x="50" y="20" width="200" height="440" rx="4" data-id="element-97" data-mp="240c2v7dxglrr" />
        <line x1="65" y1="20" x2="65" y2="460" data-id="element-98" data-mp="1q0ay3gujku70" />
        <line x1="235" y1="20" x2="235" y2="460" data-id="element-99" data-mp="1q1m31jzq47zp" />
        <line x1="50" y1="45" x2="250" y2="45" data-id="element-100" data-mp="1uyciq67m91kl" />
        <line x1="50" y1="435" x2="250" y2="435" data-id="element-101" data-mp="1uz4cdbhnkp88" />
        <line x1="50" y1="175" x2="250" y2="175" data-id="element-102" data-mp="2inx3munby8wi" />
        <line x1="50" y1="305" x2="250" y2="305" data-id="element-103" data-mp="2ip8e1dba6ewl" />
        <line x1="150" y1="20" x2="150" y2="175" data-id="element-104" data-mp="2mqa69a6s5qp2" />
        <line x1="150" y1="305" x2="150" y2="460" data-id="element-105" data-mp="2ms4ryqpvlmu7" />
      </g>
      <line x1="40" y1="240" x2="260" y2="240" stroke="#10233A" strokeWidth="5" strokeLinecap="round" data-id="element-106" data-mp="28xkl17z2spt0" />
      <path d="M150 282 Q 55 190 112 92" stroke="#10233A" strokeWidth="2" strokeDasharray="5 6" fill="none" data-id="element-107" data-mp="2dwou7ym02njc" />
      <path d="M196 120 L 204 200" stroke="#10233A" strokeWidth="2.5" fill="none" markerEnd="url(#arrow)" data-id="element-108" data-mp="31lq4zsib2ars" />
      <path d="M112 392 Q 150 360 188 392" stroke="#10233A" strokeWidth="2" fill="none" markerEnd="url(#arrow)" data-id="element-109" data-mp="36fkoauu00nqc" />
      <Dot x={112} y={84} fill="#1C6DD0" label="P" data-id="element-110" data-mp="3g7x88xpwa9q9" />
      <Dot x={196} y={110} fill="#1C6DD0" label="P" data-id="element-111" data-mp="3ban8op8skhop" />
      <Dot x={150} y={282} fill="#FFC93C" label="F" dark data-id="element-112" data-mp="3b92h98hrxev2" />
      <Dot x={112} y={404} fill="#1C6DD0" label="P" data-id="element-113" data-mp="36aisz1fpjqzj" />
      <Dot x={188} y={404} fill="#1C6DD0" label="P" data-id="element-114" data-mp="31cqzi2zezwt8" />
      <Dot x={272} y={330} fill="#10233A" label="C" data-id="element-115" data-mp="31c7j4qpexghb" />
    </svg>;
}